
const data = {
    nonSSO: [
        "local",
        "v2",
        "expense",
        "vendor",
        "localhost",
        "travel",
        "v2-uat",
        "expense-uat",
        "v2-prep",
        "expense-prep",
        "expense-sdx",
        "dev-icici-prep-crd",
        "v2-new-ui",
        "segfault1",
        "v2-nui-prep"
    ],
    isSSO: function() {
        const subDomain = window.location.hostname.split(".")[0];
        return !this.nonSSO.includes(subDomain);
    }
};

export default data;
